import SingleInvoice from 'features/Invoice/SingleInvoice'
import { useState } from 'react'

import styles from './InvoiceForPrint.module.scss'

const InvoiceForPrint = () => {
  const [invoiceList, setInvoiceList] = useState()

  function passInvoiceData(invoiceData) {
    setInvoiceList(invoiceData)
  }

  window.passInvoiceData = passInvoiceData

  if (!invoiceList) {
    return <div id="ready">waiting for function execution</div>
  }

  return (
    <div className={styles.invoiceWrapper}>
      <div id="printArea" className={styles.printArea}>
        {invoiceList?.map(invoice => (
          <SingleInvoice key={invoice.invoiceId} {...invoice} />
        ))}
      </div>
    </div>
  )
}

export default InvoiceForPrint
